import { UniqueFields } from '../pages'

export const toggleField = (
  name: string,
  all: UniqueFields,
  selected: UniqueFields
) => {
  const exists = selected.some((field) => field.name === name)

  if (exists) {
    return selected.filter((field) => field.name !== name)
  }

  const field = all.find((field) => field.name === name)

  return field ? [...selected, field] : selected
}
